import { createPortal } from 'react-dom'
import { Modal } from 'react-bootstrap'
import { KTSVG } from '_metronic/helpers'

interface Props {
  isOpen: boolean
  documentNo?: string
  fileUrl?: string | null
  mimeType?: string | null
  onClose: () => void
}

const SignedFilePreviewModal: React.FC<Props> = ({
  isOpen,
  documentNo,
  fileUrl,
  mimeType,
  onClose,
}) => {
  const modalsRoot = document.getElementById('root-modals') || document.body
  const isImage = Boolean(mimeType?.startsWith('image/'))

  return createPortal(
    <Modal
      id='kt_modal_signed_file_preview'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={isOpen}
      onHide={onClose}>
      <div className='modal-content'>
        <div className='modal-header'>
          <h2>แสดงลายเซ็น{documentNo ? ` — ${documentNo}` : ''}</h2>
          <div className='btn btn-sm btn-icon btn-active-light-danger' onClick={onClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/general/gen040.svg' />
          </div>
        </div>

        <div className='modal-body p-8'>
          {!fileUrl && (
            <div className='alert alert-warning mb-0'>ไม่พบไฟล์ลายเซ็นที่อัปโหลด</div>
          )}

          {fileUrl && isImage && (
            <div className='text-center'>
              <img
                src={fileUrl}
                alt='Signed file'
                style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }}
              />
            </div>
          )}

          {fileUrl && !isImage && (
            <iframe
              title='Signed file preview'
              src={fileUrl}
              className='w-100 border rounded'
              style={{ minHeight: '70vh' }}
            />
          )}
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export default SignedFilePreviewModal
